import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import Root from './Root';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
